export const agentCodeRegex = new RegExp('^(\\d{4,12})$');

// const agentCodeRegex = new RegExp('^(\d{4,12})$');
